import { useMenuDropdown } from '@shared/ui';
import { DropdownItem, DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu';

interface Props {
  onExclude?: () => void;
}

export const EventVisitorMenu: React.FC<Props> = ({ onExclude }) => {
  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});

  const handleClickExclude = () => {
    // console.log('исключил');
    onExclude?.();
    onClose();
  };

  const handleClickRefund = () => {
    // console.log('вернул деньги');
    onClose();
  };

  return (
    <DropdownMenuWithButton
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
    >
      <DropdownItem onClick={handleClickExclude}>Исключить участника</DropdownItem>
      <DropdownItem onClick={handleClickRefund}>Вернуть оплату</DropdownItem>
    </DropdownMenuWithButton>
  );
};
